import React from 'react';

import { AggregationDisplay, MappedAggregations } from 'src/components/CategoryListingPage/utils/cleanAggregations';
import { Svg } from 'src/components/Svg/Svg';

import classes from './CurrentSelection.scss';

export type CurrentSelectionsProps = {
    includeTitle?: boolean;
    mappedAggregations: MappedAggregations;
    remove(code: string, value: string, label: string);
    removeAll();
    selections: AggregationDisplay[];
};

export function CurrentSelection(props: CurrentSelectionsProps) {
    const { selections, remove, removeAll } = props;

    const selectionsTotal = selections.length;
    const hasMoreThanOneSelection = selectionsTotal > 1;
    const filterSelectionsText = `${selectionsTotal} ${hasMoreThanOneSelection ? 'filters' : 'filter'} applied`;

    if (selections.length === 0) {
        return null;
    }

    return (
        <div className={classes.current} data-test-id="category-current-filter">
            {props.includeTitle && <h2 className={classes.label}>{filterSelectionsText}</h2>}

            <ul className={classes.list}>
                {selections.map((selection) => {
                    const { option, attribute_code, label } = selection;

                    return (
                        <li key={option.value} className={classes.item}>
                            <button
                                className={classes.itemBtn}
                                onClick={() => remove(selection.attribute_code, option.value, option.displayLabel)}
                                type="button"
                            >
                                {attribute_code && (
                                    <span>
                                        {label}: <b>{option.displayLabel}</b>
                                    </span>
                                )}
                                <Svg name="close" />
                            </button>
                        </li>
                    );
                })}
                <li className={classes.item}>
                    <button
                        data-test-id="LayeredNav__CurrentSelection__ClearAllFilters"
                        onClick={removeAll}
                        className={classes.itemBtn}
                        type="button"
                    >
                        <span>Clear all</span>
                        <Svg name="close" />
                    </button>
                </li>
            </ul>
        </div>
    );
}

export default CurrentSelection;
